import { LatLngExpression } from "leaflet";
import React from "react";
import { Polyline } from "react-leaflet";
import { ISTATUS } from "../../../../models/common/CommonModels";
import { filledColorSelection } from "../../../../utils/common/CommonHelperFunctions";

export interface IRunwaySegmentProps {
  idx: number;
  line: LatLngExpression[];
  status: ISTATUS;
  haloWidth: number;
  weight: number;
}

const RunwaySegment: React.FC<IRunwaySegmentProps> = ({
  idx,
  line,
  status,
  haloWidth,
  weight,
}) => {
  return (
    <React.Fragment key={`seg-${idx}`}>
      <Polyline
        positions={line}
        pathOptions={{
          color: "#fff",
          weight: haloWidth,
          opacity: 1,
          lineCap: "round",
          lineJoin: "round",
        }}
      />
      <Polyline
        positions={line}
        pathOptions={{
          color: filledColorSelection(status),
          weight,
          opacity: 1,
          lineCap: "round",
          lineJoin: "round",
        }}
      />
    </React.Fragment>
  );
};

export default RunwaySegment;
